import hash from 'object-hash';

const QuickCart = () => {
  return {
    isOpen: false,

    hasFreeShipping() {
      return Math.max(this.$store.Cart.cart.total_price / 100, 0) >= 75;
    },

    freeShippingProgress() {
      const total = Math.max(this.$store.Cart.cart.total_price, 0) / 100;
      const percentage = Math.min(Math.round((total / 75) * 100), 100);
      return `${percentage}%`;
    },

    toFreeShipping() {
      return (75 - Math.max(this.$store.Cart.cart.total_price / 100, 0)) * 100;
    },

    // line_items are not guarenteed to have a unique key (discounts)
    getKey(item) {
      const key = hash(item);
      return key;
    },

    handleClose() {
      document.querySelector('body').classList.remove('overflow-hidden');
      this.isOpen = false;
    },

    handleDelete(key) {
      this.$store.Cart.updateCart({ key, quantity: 0 });
    },

    handleQuantityChange(index, quantity) {
      this.$store.Cart.changeCart({ line: index + 1, quantity });
    },

    handleOpen() {
      document.querySelector('body').classList.add('overflow-hidden');
      this.isOpen = true;
    },
  };
};

export default QuickCart;
